import { z } from "zod";

import {
  eventAnalyticsEventCategory,
  eventAnalyticsInteractionType,
  system,
} from "@smart/bridge-types-basic";
import { buildSNSSQSDef } from "@smart/itops-constructs-basic";
import { buildNamespace } from "@smart/itops-types-basic";
import { wrapSchema } from "@smart/itops-utils-basic";

const AnalyticsAdapterNS = buildNamespace({
  system,
  entity: "AnalyticsAdapter",
} as const);

export const AnalyticsAdapterSchema = z.object({
  operationId: z.string(),
  userUri: z.string(),
  userId: z.string(),
  userEmail: z.string(),
  teamUri: z.string(),
  firmId: z.string(),
  firmName: z.string().optional().nullable(),
  firmSize: z.number().optional(),
  region: z.string(),
  state: z.string().optional().nullable(),
  productTier: z.string().optional().nullable(),
  product: z.string().optional().nullable(),
  billingStatus: z.string().optional().nullable(),
  platform: z.string().optional().nullable(),
  operatingSystem: z.string().optional().nullable(),
  productVersion: z.string().optional().nullable(),
  browserType: z.string().optional().nullable(),
  time: z.number(),
  isInternalUser: z.boolean(),
  sessionId: z.string().optional().nullable(),
  event: z.object({
    category: z.enum(eventAnalyticsEventCategory),
    name: z.string().optional().nullable(),
    screen: z.string().optional().nullable(),
    entryPoint: z.string().optional().nullable(),
    component: z.string().optional().nullable(),
    jiraKey: z.string().optional().nullable(),
    interactionType: z.enum(eventAnalyticsInteractionType).optional(),
    properties: z.record(z.any()).optional().nullable(),
  }),
});

const analyticsAdapterGuard = wrapSchema(AnalyticsAdapterSchema);

export const AnalyticsAdapterDef = buildSNSSQSDef({
  namespace: AnalyticsAdapterNS,
  guard: analyticsAdapterGuard,
  maxAttempts: 1,
  sqsOnly: false,
  groupKey: "userId",
  idKey: "operationId",
});
